// extracted by mini-css-extract-plugin
module.exports = {"img":"parameter_img_d0fdM","formWarp":"parameter_formWarp_1P59m","button":"parameter_button__osKw"};